/* Arcmedia.Lda - Main JavaScript */
/* ================================================ */

// Reveal-on-scroll
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('in');
      io.unobserve(e.target);
    }
  });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal').forEach(el => io.observe(el));

// Adaptive wordmark: guarantees the full word fits the viewport at any zoom level.
function fitWordmark() {
  const wordmark = document.querySelector('.hero-wordmark');
  const word = wordmark && wordmark.querySelector('.word');
  if (!wordmark || !word) return;
  const containerWidth = wordmark.clientWidth - 64;
  if (containerWidth <= 0) return;
  word.style.fontSize = '';
  word.style.transform = '';
  const naturalWidth = word.scrollWidth;
  if (naturalWidth > containerWidth) {
    const scale = containerWidth / naturalWidth;
    const currentFs = parseFloat(getComputedStyle(word).fontSize);
    word.style.fontSize = (currentFs * scale * 0.99) + 'px';
  }
}

window.addEventListener('load', fitWordmark);
window.addEventListener('resize', fitWordmark);
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(fitWordmark);
}

// ============== ANIMATED ROTATING GLOBE ==============
(function initGlobe() {
  const dotsGroup = document.getElementById('globeDots');
  const mozGroup = document.getElementById('globeMoz');
  if (!dotsGroup || !mozGroup) return;

  const WORLD_DOTS = [[-59.57,-80.04],[-65.74,-80.55],[-59.57,-80.04],[-163.71,-78.6],[-45.15,-78.05],[-46.51,-80.59],[-51.85,-79.95],[-48.15,-78.05],[-119.29,-73.83],[-125.56,-73.48],[-125.56,-73.48],[-98.2,-72.48],[-100.43,-71.86],[-69.96,-72.31],[-74.95,-72.07],[-71.72,-70.31],[-69.06,-70.07],[-177.26,-84.45],[-175.94,-84.1],[-169.0,-84.12],[-155.19,-85.1],[-146.83,-84.53],[-152.66,-82.45],[-152.1,-81.0],[-148.06,-79.65],[-157.27,-78.38],[-153.74,-77.07],[-146.11,-76.48],[-142.79,-75.34],[-135.22,-74.3],[-128.24,-74.32],[-119.7,-74.48],[-113.3,-74.03],[-107.56,-75.18],[-100.12,-74.87],[-103.68,-72.62],[-97.69,-73.56],[-90.09,-73.32],[-83.88,-73.52],[-77.92,-73.42],[-71.62,-73.26],[-67.25,-71.64],[-68.45,-69.32],[-67.25,-66.88],[-63.63,-64.9],[-59.16,-63.7],[-59.05,-64.37],[-62.65,-65.48],[-64.88,-67.15],[-63.2,-69.23],[-61.38,-72.01],[-61.96,-74.44],[-68.45,-76.01],[-77.24,-76.71],[-76.5,-78.12],[-75.36,-80.26],[-63.25,-81.75],[-55.36,-82.57],[-42.81,-82.08],[-32.31,-80.77],[-31.62,-79.3],[-33.9,-77.89],[-26.16,-76.36],[-18.91,-75.44],[-16.11,-73.46],[-11.02,-71.54],[-6.87,-70.93],[-0.66,-71.23],[5.16,-70.62],[10.25,-70.48],[15.13,-70.4],[21.45,-70.07],[27.09,-70.46],[32.75,-69.38],[37.2,-69.17],[41.96,-68.6],[47.44,-67.72],[51.79,-66.25],[57.16,-66.25],[61.43,-67.95],[66.91,-67.86],[68.6,-69.93],[67.95,-71.85],[72.46,-71.01],[76.62,-69.62],[80.93,-67.88],[85.65,-67.09],[89.67,-67.15],[95.02,-67.17],[100.39,-66.91],[104.91,-66.33],[111.06,-66.43],[115.6,-66.7],[121.65,-66.88],[127.0,-66.56],[132.94,-66.39],[135.87,-66.03],[140.81,-66.82],[146.0,-67.6],[152.5,-68.87],[158.03,-69.48],[163.84,-70.72],[170.5,-71.4],[169.29,-73.66],[164.24,-75.46],[164.28,-77.83],[161.77,-79.16],[161.63,-81.69],[169.41,-83.83],[-180.0,-84.71],[-66.96,-54.9],[-72.27,-54.49],[-70.59,-53.62],[-58.55,-51.1],[-61.2,-51.85],[68.72,-49.24],[70.28,-49.71],[148.36,-42.06],[146.05,-43.55],[173.02,-40.92],[173.22,-42.97],[170.62,-45.91],[166.51,-45.85],[171.13,-42.51],[174.61,-36.16],[177.44,-37.96],[176.94,-39.45],[175.07,-41.43],[174.57,-38.8],[173.06,-35.24],[167.12,-22.16],[164.03,-20.11],[167.12,-22.16],[177.29,-17.72],[178.73,-17.01],[-179.92,-16.5],[167.85,-16.47],[166.63,-14.63],[50.2,-16.0],[49.43,-17.95],[46.28,-25.18],[43.35,-22.78],[44.47,-19.44],[44.94,-16.18],[48.0,-14.09],[49.54,-12.47],[144.9,-14.59],[146.16,-17.76],[148.72,-20.63],[150.9,-23.46],[153.09,-27.26],[152.89,-31.64],[150.33,-35.67],[147.38,-38.22],[144.49,-38.09],[139.99,-37.4],[138.21,-34.39],[137.81,-32.9],[134.61,-33.22],[129.53,-31.59],[124.03,-33.48],[119.89,-33.98],[116.62,-35.03],[115.68,-32.9],[114.64,-28.81],[113.78,-26.55],[113.63,-24.68],[114.15,-21.76],[117.16,-20.62],[119.8,-19.98],[122.31,-17.26],[124.26,-16.33],[126.13,-14.35],[128.98,-14.88],[130.62,-12.54],[132.36,-11.13],[135.88,-11.96],[135.96,-13.32],[137.07,-15.87],[140.22,-17.71],[141.56,-14.56],[141.93,-11.88],[143.12,-11.9],[162.4,-10.83],[120.29,-10.26],[160.85,-9.87],[160.69,-9.61],[160.92,-8.32],[123.55,-9.9],[126.96,-8.27],[117.9,-8.09],[116.74,-9.03],[121.25,-8.93],[122.9,-8.09],[158.36,-7.32],[156.9,-7.18],[110.54,-6.88],[114.57,-8.75],[108.69,-7.64],[107.26,-5.96],[134.11,-6.14],[155.6,-6.92],[155.06,-5.57],[151.3,-5.84],[148.4,-5.44],[150.81,-5.46],[152.32,-4.87],[127.0,-3.13],[128.59,-3.43],[152.83,-4.77],[150.94,-2.5],[153.14,-4.5],[138.33,-1.7],[145.27,-4.37],[147.19,-7.39],[149.74,-9.87],[147.91,-10.13],[143.29,-8.25],[139.13,-8.1],[137.93,-5.39],[132.76,-3.75],[132.23,-2.21],[133.98,-0.78],[121.06,0.38],[123.26,-1.08],[123.17,-4.68],[121.49,-4.57],[120.43,-5.53],[118.77,-2.8],[121.67,1.01],[128.63,0.26],[127.4,1.01],[105.82,-5.85],[100.9,-2.05],[97.18,3.31],[98.37,4.27],[103.08,0.56],[104.89,-2.34],[119.0,0.9],[116.15,-4.01],[112.07,-3.48],[109.09,-0.46],[111.37,2.7],[115.45,5.45],[118.35,5.71],[117.31,3.24],[126.2,6.27],[123.94,6.89],[121.92,7.19],[124.76,8.96],[81.22,6.2],[81.31,8.56],[-61.95,10.09],[123.98,10.28],[122.84,10.26],[118.5,9.32],[119.69,10.55],[123.1,11.17],[125.5,12.16],[124.76,10.84],[125.23,12.54],[121.18,13.43],[122.17,17.81],[122.26,14.22],[123.3,13.03],[120.68,14.27],[119.88,16.36],[-65.85,17.98],[-65.77,18.43],[-78.22,18.45],[-76.9,17.87],[-69.95,19.65],[-68.69,18.21],[-70.67,18.43],[-72.84,18.14],[-72.69,18.45],[-72.58,19.87],[110.21,20.1],[-155.69,18.92],[-155.92,20.17],[-154.81,19.51],[-156.59,20.78],[-156.08,20.64],[-157.65,21.32],[-158.03,21.72],[-159.75,22.14],[-78.35,22.51],[-75.67,20.73],[-76.32,19.95],[-78.72,21.6],[-81.79,22.64],[-84.97,21.9],[-82.27,23.19],[-78.03,24.29],[121.18,22.79],[121.95,25.0],[-78.51,26.87],[-77.34,26.53],[134.2,33.2],[132.93,34.06],[33.98,35.06],[32.8,35.14],[25.03,35.43],[24.73,35.09],[15.1,36.62],[14.76,38.14],[8.81,38.91],[140.98,37.14],[135.79,33.46],[132.0,33.15],[129.41,33.3],[135.68,35.53],[139.88,40.56],[140.98,37.14],[9.39,43.01],[144.06,42.99],[140.31,43.33],[-63.66,46.55],[-64.39,46.73],[-64.52,49.87],[-124.01,48.37],[-128.44,50.54],[-124.92,49.48],[-55.47,49.94],[-53.09,48.69],[-53.96,47.63],[-57.33,47.57],[-57.36,50.72],[-132.71,54.04],[-132.55,53.1],[144.65,48.98],[142.09,45.97],[141.59,51.94],[143.26,52.74],[-9.17,52.86],[-6.2,53.87],[10.9,55.78],[-154.67,57.46],[-3.0,58.63],[-2.09,55.91],[1.56,52.1],[-2.96,50.7],[-3.41,51.43],[-3.09,53.4],[-5.05,55.78],[-4.21,58.55],[-166.47,60.38],[-80.36,62.02],[-83.07,62.16],[-171.73,63.78],[-169.53,62.98],[-85.16,65.66],[-81.55,63.98],[-84.1,63.57],[-85.88,65.74],[-17.79,63.68],[-22.19,65.08],[-19.06,66.28],[-77.24,67.59],[-75.87,67.15],[-174.57,67.06],[-172.95,64.25],[-178.36,65.39],[179.99,64.97],[179.49,62.57],[170.7,60.34],[163.54,59.87],[162.13,56.12],[158.23,51.94],[156.76,57.36],[164.47,62.55],[154.22,59.76],[148.55,59.16],[137.19,53.98],[140.6,51.24],[135.51,43.99],[130.78,42.22],[129.01,40.48],[127.79,39.05],[128.18,34.89],[126.86,36.89],[124.98,37.95],[125.32,39.55],[121.59,39.36],[119.02,39.25],[119.7,37.16],[120.64,36.11],[121.91,31.69],[121.68,28.23],[115.89,22.78],[110.79,21.4],[108.05,21.55],[108.27,16.08],[106.4,9.53],[103.09,11.15],[100.02,12.31],[100.46,7.43],[103.38,4.85],[104.25,1.63],[100.69,3.94],[99.52,7.34],[98.55,9.93],[97.78,14.84],[94.19,16.04],[92.37,20.67],[90.59,22.39],[88.89,21.69],[83.94,18.3],[80.33,15.9],[79.34,10.31],[76.59,8.9],[74.44,14.62],[71.17,20.76],[67.44,23.95],[59.61,25.38],[54.72,26.48],[49.58,29.99],[48.42,28.55],[50.11,25.94],[51.01,26.01],[51.76,24.29],[55.44,25.44],[56.4,24.93],[59.45,22.66],[58.49,20.43],[57.24,18.95],[55.27,17.23],[52.19,15.94],[47.94,14.01],[45.14,12.95],[43.25,13.77],[42.82,15.91],[41.22,18.67],[39.07,22.58],[36.93,25.6],[34.79,28.61],[34.16,27.82],[32.73,28.7],[35.49,23.75],[37.11,19.81],[39.81,15.44],[43.32,12.39],[44.12,10.45],[48.38,11.38],[51.11,12.02],[50.07,8.08],[44.07,1.05],[40.64,-2.5],[38.74,-5.91],[39.19,-8.49],[40.56,-12.64],[38.54,-17.1],[34.7,-20.5],[35.37,-23.53],[32.57,-25.73],[32.2,-28.75],[28.92,-32.17],[25.17,-33.8],[20.69,-34.42],[18.38,-34.14],[17.57,-30.73],[14.99,-26.12],[13.35,-20.87],[11.78,-15.79],[13.64,-12.04],[12.93,-8.96],[12.18,-5.79],[8.83,-0.78],[9.79,3.07],[7.46,4.41],[4.33,6.27],[-1.06,5.0],[-5.83,4.99],[-9.91,5.59],[-13.12,8.16],[-14.69,10.66],[-16.31,11.96],[-17.62,14.73],[-16.15,18.11],[-17.02,21.42],[-15.42,24.36],[-13.14,27.64],[-9.82,31.18],[-6.24,35.15],[-2.17,35.17],[4.82,36.86],[9.51,37.35],[10.59,35.95],[11.11,33.29],[15.71,31.38],[19.82,31.75],[23.61,32.19],[28.45,31.03],[31.96,30.93],[34.49,31.61],[35.98,34.61],[35.55,36.56],[30.39,36.26],[26.8,38.99],[32.35,41.74],[40.37,41.01],[39.95,43.44],[37.67,46.64],[35.82,46.65],[35.24,44.94],[33.59,45.85],[29.6,45.29],[27.68,42.58],[27.19,40.69],[23.72,40.69],[22.85,39.66],[23.11,37.92],[21.3,37.64],[19.96,39.91],[19.16,41.96],[15.18,44.24],[13.66,45.14],[12.38,44.89],[15.92,41.96],[18.48,40.17],[17.05,38.9],[16.11,38.96],[13.63,41.19],[9.7,44.04],[4.56,43.4],[0.72,40.68],[-1.44,37.44],[-5.87,36.03],[-8.9,36.87],[-9.05,39.76],[-8.98,42.59],[-3.52,43.46],[-4.49,47.96],[1.34,50.13],[6.08,53.51],[8.57,54.4],[9.42,57.17],[10.91,56.46],[10.95,54.36],[14.8,54.05],[19.89,54.87],[23.32,57.01],[23.34,59.19],[28.07,60.5],[21.54,61.7],[25.3,65.53],[17.85,62.75],[16.45,57.04],[11.79,57.44],[5.31,59.66],[14.76,67.81],[26.37,70.99],[33.77,69.3],[38.38,66.0],[37.01,63.85],[39.76,65.5],[44.19,67.95],[46.35,66.67],[53.49,68.2],[61.08,68.94],[69.18,68.62],[66.7,71.03],[71.85,71.41],[71.28,66.32],[74.47,68.33],[74.89,72.12],[75.9,71.87],[82.25,73.85],[90.26,75.64],[100.76,76.43],[106.97,76.97],[113.89,75.33],[113.02,73.98],[123.2,72.97],[128.46,71.98],[137.5,71.35],[150.35,71.61],[160.94,69.44],[170.82,69.01],[-180.0,68.96],[49.39,39.4],[50.84,36.87],[53.1,39.29],[54.01,41.55],[52.69,42.44],[51.28,44.51],[52.04,46.8],[46.68,44.61],[-96.27,68.76],[-97.16,69.86],[178.9,70.78],[-177.66,71.13],[-89.21,69.26],[-85.52,69.88],[-81.26,67.6],[-87.03,65.21],[-91.93,62.84],[-92.76,57.85],[-86.07,55.72],[-81.4,52.16],[-78.23,55.14],[-77.34,59.85],[-73.84,62.44],[-69.29,58.96],[-63.81,59.44],[-57.98,54.95],[-56.41,51.77],[-65.36,50.3],[-70.26,46.99],[-64.8,46.99],[-59.8,45.92],[-66.16,44.47],[-69.06,43.98],[-70.08,41.78],[-71.86,41.32],[-73.35,40.63],[-74.91,38.94],[-75.06,38.4],[-76.35,39.15],[-75.97,36.9],[-78.55,33.86],[-81.49,30.73],[-80.09,26.21],[-81.71,25.87],[-83.71,29.94],[-87.53,30.27],[-89.22,29.29],[-92.5,29.55],[-97.14,27.83],[-97.7,24.27],[-96.53,19.89],[-92.79,18.53],[-90.28,21.0],[-86.85,20.85],[-88.09,18.52],[-88.2,17.49],[-88.93,15.89],[-87.62,15.88],[-86.0,16.01],[-84.37,15.83],[-83.29,14.68],[-83.47,12.42],[-83.66,10.94],[-81.81,8.95],[-79.57,9.61],[-77.35,8.67],[-74.91,11.08],[-71.75,12.44],[-71.62,10.97],[-71.35,10.21],[-68.88,11.44],[-64.89,10.08],[-62.39,9.95],[-59.1,8.0],[-55.95,5.77],[-51.82,4.57],[-49.95,1.05],[-46.57,-0.94],[-39.98,-2.87],[-34.9,-6.74],[-38.42,-13.04],[-39.58,-18.26],[-43.08,-22.97],[-48.64,-26.62],[-51.58,-31.78],[-55.67,-34.75],[-57.22,-35.29],[-61.24,-38.93],[-63.77,-41.17],[-63.46,-42.56],[-67.29,-45.55],[-67.82,-49.87],[-69.46,-52.29],[-73.7,-52.83],[-75.18,-47.71],[-72.72,-42.38],[-73.22,-39.26],[-71.44,-32.42],[-70.4,-23.63],[-73.45,-16.36],[-78.09,-10.38],[-80.93,-5.69],[-80.37,-2.69],[-80.02,0.36],[-78.66,2.27],[-77.31,4.67],[-78.43,8.05],[-79.76,8.59],[-80.42,7.27],[-82.13,8.18],[-83.71,8.66],[-84.71,9.91],[-85.8,10.14],[-86.53,11.81],[-87.32,12.98],[-89.26,13.46],[-92.23,14.54],[-96.56,15.65],[-101.67,17.65],[-105.49,19.95],[-105.6,21.87],[-109.26,25.58],[-111.18,27.94],[-113.15,31.17],[-114.67,30.16],[-112.96,28.43],[-110.99,25.29],[-109.43,23.19],[-112.18,24.74],[-113.85,26.9],[-114.16,28.57],[-117.13,32.53],[-119.44,34.35],[-122.51,37.78],[-124.21,42.0],[-124.69,48.18],[-122.84,49.0],[-127.85,52.33],[-131.97,55.5],[-137.8,58.5],[-147.11,60.89],[-151.71,59.16],[-152.58,60.06],[-156.56,56.98],[-162.24,55.02],[-161.81,55.9],[-157.55,58.33],[-159.98,58.57],[-162.52,59.99],[-165.73,62.08],[-161.54,63.46],[-162.45,64.56],[-168.11,65.67],[-162.49,66.73],[-164.43,68.91],[-158.12,70.82],[-152.27,70.6],[-143.59,70.15],[-135.63,69.32],[-128.36,70.01],[-123.06,69.56],[-115.25,68.91],[-108.88,67.38],[-105.34,68.56],[-98.56,68.4],[-94.23,69.07],[-92.88,71.32],[-112.44,72.95],[-108.4,73.09],[-102.79,70.5],[-104.24,68.91],[-113.86,69.01],[-113.72,70.19],[-116.11,71.31],[-114.17,73.12],[-104.5,73.42],[-79.77,72.8],[-86.56,73.16],[-78.77,72.35],[-71.2,70.92],[-64.86,67.85],[-66.72,66.39],[-64.67,63.39],[-66.17,61.93],[-74.84,64.68],[-73.96,65.46],[-74.84,68.55],[-79.49,69.87],[-88.47,71.22],[-86.56,73.16],[-96.54,72.56],[-102.48,72.83],[140.04,73.32],[-93.2,72.77],[-94.5,74.13],[-123.09,70.9],[-124.92,74.29],[-116.77,73.22],[147.98,74.78],[-94.16,74.59],[-93.61,74.98],[137.51,75.95],[-97.7,75.74],[-102.57,76.34],[-107.82,75.85],[-112.22,74.42],[-116.35,76.2],[-109.58,76.79],[53.41,71.21],[53.51,73.75],[66.21,76.81],[58.48,74.31],[-93.57,76.78],[-87.84,75.57],[-79.83,74.92],[-89.77,74.52],[-97.12,76.75],[-118.04,76.48],[-117.57,77.5],[-94.42,77.82],[-112.73,78.05],[20.73,77.68],[-109.66,78.6],[-109.66,78.6],[-97.34,78.83],[-101.3,78.02],[-103.53,79.16],[102.09,79.35],[19.03,78.56],[14.67,77.74],[15.14,79.67],[25.93,79.52],[20.46,80.6],[48.89,80.34],[46.8,80.77],[51.14,80.55],[91.18,80.34],[-87.02,79.66],[-93.95,78.75],[-96.01,80.6],[-89.45,80.51],[-61.85,82.63],[-67.84,80.9],[-75.53,79.2],[-79.76,77.21],[-86.11,76.3],[-87.65,77.97],[-85.1,79.35],[-84.1,80.58],[-90.1,82.08],[-82.42,82.86],[-70.67,83.17],[-31.9,82.2],[-23.17,81.15],[-16.85,80.35],[-18.47,76.98],[-19.37,74.3],[-22.31,72.63],[-21.75,70.66],[-23.73,70.18],[-32.81,67.74],[-40.67,64.84],[-43.38,60.1],[-51.63,63.63],[-52.98,68.36],[-53.46,69.28],[-53.11,71.2],[-56.12,73.65],[-66.07,76.14],[-71.04,77.64],[-68.02,80.12],[-57.21,82.19],[-44.52,81.66],[-35.09,83.65]];

  const MOZ_DOTS = [[40.478,-10.43],[40.167,-10.661],[39.831,-10.873],[39.46,-11.018],[39.121,-11.146],[38.754,-11.267],[38.406,-11.385],[38.042,-11.265],[37.784,-11.484],[37.443,-11.636],[37.094,-11.624],[36.788,-11.611],[36.51,-11.726],[36.196,-11.684],[36.037,-11.491],[35.732,-11.471],[35.433,-11.58],[35.055,-11.572],[34.655,-11.581],[34.5,-11.945],[34.428,-12.331],[34.529,-12.71],[34.544,-13.094],[34.595,-13.468],[34.952,-13.568],[35.215,-13.868],[35.482,-14.166],[35.716,-14.486],[35.872,-14.827],[35.801,-15.152],[35.845,-15.542],[35.815,-15.941],[35.551,-16.14],[35.285,-16.306],[35.175,-16.619],[35.267,-16.93],[35.124,-17.128],[35.151,-16.865],[34.884,-16.687],[34.662,-16.449],[34.411,-16.227],[34.289,-15.928],[34.432,-15.641],[34.541,-15.335],[34.619,-15.004],[34.547,-14.646],[34.296,-14.405],[33.943,-14.476],[33.694,-14.597],[33.45,-14.352],[33.287,-14.032],[32.912,-14.109],[32.537,-14.247],[32.151,-14.351],[31.776,-14.486],[31.411,-14.636],[31.024,-14.735],[30.641,-14.845],[30.268,-14.985],[30.326,-15.306],[30.425,-15.636],[30.461,-16.0],[30.861,-15.998],[31.199,-16.006],[31.493,-16.167],[31.847,-16.309],[32.175,-16.441],[32.556,-16.542],[32.852,-16.705],[32.853,-16.915],[32.992,-17.252],[33.013,-17.571],[32.963,-17.822],[32.973,-18.116],[33.02,-18.455],[32.94,-18.727],[32.73,-18.931],[32.865,-19.166],[32.832,-19.477],[32.977,-19.687],[33.009,-20.016],[32.863,-20.244],[32.647,-20.557],[32.508,-20.838],[32.394,-21.162],[32.332,-21.4],[32.054,-21.687],[31.775,-21.974],[31.501,-22.264],[31.355,-22.564],[31.48,-22.944],[31.562,-23.331],[31.693,-23.689],[31.888,-24.007],[31.992,-24.377],[32.002,-24.777],[32.025,-25.175],[31.994,-25.562],[31.967,-25.937],[32.082,-26.26],[32.132,-26.644],[32.308,-26.853],[32.707,-26.865],[32.959,-26.671],[32.981,-26.272],[32.974,-25.93],[32.797,-26.158],[32.791,-25.842],[32.99,-25.52],[33.342,-25.334],[33.712,-25.181],[34.085,-25.04],[34.471,-24.933],[34.841,-24.785],[35.203,-24.616],[35.411,-24.293],[35.581,-23.948],[35.47,-23.597],[35.519,-23.217],[35.594,-22.839],[35.587,-22.441],[35.519,-22.069],[35.359,-21.883],[35.247,-21.502],[35.134,-21.121],[35.059,-20.748],[34.789,-20.458],[34.82,-20.087],[35.029,-19.794],[35.344,-19.552],[35.626,-19.269],[35.917,-18.999],[36.3,-18.884],[36.555,-18.597],[36.811,-18.29],[37.067,-17.982],[37.373,-17.725],[37.72,-17.531],[38.083,-17.363],[38.448,-17.202],[38.836,-17.105],[39.174,-16.934],[39.491,-16.701],[39.836,-16.5],[40.055,-16.183],[40.283,-15.857],[40.558,-15.567],[40.702,-15.202],[40.852,-14.866],[40.833,-14.471],[40.669,-14.165],[40.62,-13.787],[40.605,-13.402],[40.619,-13.003],[40.644,-12.641],[40.608,-12.269],[40.606,-11.98],[40.482,-11.649],[40.463,-11.28],[40.54,-10.942],[40.65,-10.721]];

  const MAPUTO = [32.58, -25.97];

  // Globe geometry: zoomed in on Mozambique with surrounding African context
  const CX = 200;
  const CY = 200;
  const R = 1100;                       // tight zoom: Mozambique fills the viewport
  const INITIAL_LON = -35;              // centre roughly on Mozambique mid longitude
  const TILT_DEG = -18;                 // X-tilt brings southern hemisphere up to centre
  const TILT_RAD = TILT_DEG * Math.PI / 180;
  const TILT_SIN = Math.sin(TILT_RAD);
  const TILT_COS = Math.cos(TILT_RAD);

  // Pre-compute trig for each dot
  const worldPrecomp = WORLD_DOTS.map(([lon, lat]) => {
    const phi = lat * Math.PI / 180;
    const lam = lon * Math.PI / 180;
    return {
      y: -Math.sin(phi),
      cosPhi: Math.cos(phi),
      lambda: lam
    };
  });

  const mozPrecomp = MOZ_DOTS.map(([lon, lat]) => {
    const phi = lat * Math.PI / 180;
    const lam = lon * Math.PI / 180;
    return {
      y: -Math.sin(phi),
      cosPhi: Math.cos(phi),
      lambda: lam
    };
  });

  // World coastline dots: provides surrounding land context
  const worldEls = worldPrecomp.map(() => {
    const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c.setAttribute('r', '1.6');
    c.setAttribute('fill', '#F5F1EA');
    dotsGroup.appendChild(c);
    return c;
  });

  // Mozambique highlight dots: subtle, refined outline
  const mozEls = mozPrecomp.map(() => {
    const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c.setAttribute('r', '1.1');
    c.setAttribute('fill', '#F0C13E');
    mozGroup.appendChild(c);
    return c;
  });

  // ============== DELIVERY PATH ARCS: flights from Maputo to provincial capitals ==============
  // Visualises delivery routes from Maputo to nine provincial capitals across Mozambique.
  // All arcs originate in Maputo City and terminate at provincial capitals.
  const DESTINATIONS = [
    { name: 'Xai-Xai',    lon: 33.64,  lat: -25.05 },  // Gaza
    { name: 'Inhambane',  lon: 35.38,  lat: -23.86 },  // Inhambane
    { name: 'Beira',      lon: 34.84,  lat: -19.84 },  // Sofala
    { name: 'Chimoio',    lon: 33.48,  lat: -19.12 },  // Manica
    { name: 'Tete',       lon: 33.59,  lat: -16.16 },  // Tete
    { name: 'Quelimane',  lon: 36.89,  lat: -17.88 },  // Zambezia
    { name: 'Nampula',    lon: 39.27,  lat: -15.12 },  // Nampula
    { name: 'Lichinga',   lon: 35.24,  lat: -13.31 },  // Niassa
    { name: 'Pemba',      lon: 40.52,  lat: -12.97 }   // Cabo Delgado
  ];

  const ARC_SEGMENTS = 48;       // points along each arc, for smoother flight curves
  const ARC_LIFT = 0.05;         // gentle bulge, so arcs stay close to the surface within Mozambique

  // Pre-compute 3D unit vectors for Maputo and destinations
  function lonLatToVec(lon, lat) {
    const phi = lat * Math.PI / 180;
    const lam = lon * Math.PI / 180;
    return {
      x: Math.cos(phi) * Math.sin(lam),
      y: -Math.sin(phi),
      z: Math.cos(phi) * Math.cos(lam)
    };
  }

  const maputoVec = lonLatToVec(MAPUTO[0], MAPUTO[1]);

  // Apply fixed Y-axis offset (centring on Mozambique longitude) + X-axis tilt
  // No animated rotation: the view is static, focused on Mozambique
  const FIXED_LON_RAD = INITIAL_LON * Math.PI / 180;
  const FIXED_SIN_R = Math.sin(FIXED_LON_RAD);
  const FIXED_COS_R = Math.cos(FIXED_LON_RAD);

  function transform(v) {
    // Y rotation (fixed): centres the view on the Mozambique meridian
    const x1 = v.x * FIXED_COS_R + v.z * FIXED_SIN_R;
    const y1 = v.y;
    const z1 = -v.x * FIXED_SIN_R + v.z * FIXED_COS_R;
    // X tilt (fixed): brings southern latitudes up to the centre
    return {
      x: x1,
      y: y1 * TILT_COS + z1 * TILT_SIN,
      z: -y1 * TILT_SIN + z1 * TILT_COS
    };
  }

  // Project a unit vector to SVG coordinates (with optional radial lift)
  function project(v, lift) {
    const r = R * (lift || 1);
    return { x: CX + r * v.x, y: CY + r * v.y };
  }

  // Pre-compute static projected screen positions for Maputo & all destinations
  const maputoScreen = project(transform(maputoVec));

  // ============== Build arc geometry once (static, no per-frame recompute) ==============
  // For each destination, sample ARC_SEGMENTS+1 points along the great-circle arc
  // (with lift) and store both the projected coordinates and cumulative arc lengths.
  const arcs = DESTINATIONS.map((dst) => {
    const destVec = lonLatToVec(dst.lon, dst.lat);
    const mTrans = transform(maputoVec);
    const dTrans = transform(destVec);

    // Angular distance for slerp (computed in view-space, same as in original space)
    const dot = mTrans.x * dTrans.x + mTrans.y * dTrans.y + mTrans.z * dTrans.z;
    const omega = Math.acos(Math.max(-1, Math.min(1, dot)));
    const sinOmega = Math.sin(omega);

    // Sample points along the arc
    const points = [];
    for (let i = 0; i <= ARC_SEGMENTS; i++) {
      const t = i / ARC_SEGMENTS;
      const w1 = Math.sin((1 - t) * omega) / sinOmega;
      const w2 = Math.sin(t * omega) / sinOmega;
      const v = {
        x: w1 * mTrans.x + w2 * dTrans.x,
        y: w1 * mTrans.y + w2 * dTrans.y,
        z: w1 * mTrans.z + w2 * dTrans.z
      };
      const lift = 1 + ARC_LIFT * Math.sin(t * Math.PI);
      points.push({ x: CX + R * v.x * lift, y: CY + R * v.y * lift });
    }

    // Build full path string + cumulative segment lengths
    let pathStr = `M${points[0].x.toFixed(1)} ${points[0].y.toFixed(1)}`;
    const cumLen = [0];
    for (let i = 1; i < points.length; i++) {
      const dx = points[i].x - points[i - 1].x;
      const dy = points[i].y - points[i - 1].y;
      cumLen.push(cumLen[i - 1] + Math.sqrt(dx * dx + dy * dy));
      pathStr += ` L${points[i].x.toFixed(1)} ${points[i].y.toFixed(1)}`;
    }
    const totalLen = cumLen[cumLen.length - 1];

    // Path element: uses dasharray to reveal progressively during flight
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', pathStr);
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', '#F0C13E');
    path.setAttribute('stroke-width', '1');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('opacity', '0');
    path.setAttribute('stroke-dasharray', `0 ${totalLen}`);
    mozGroup.appendChild(path);

    // Endpoint (destination) marker: appears and pulses on landing
    const endPt = points[points.length - 1];
    const endDot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    endDot.setAttribute('cx', endPt.x.toFixed(1));
    endDot.setAttribute('cy', endPt.y.toFixed(1));
    endDot.setAttribute('r', '2.2');
    endDot.setAttribute('fill', '#F5F1EA');
    endDot.setAttribute('stroke', '#F0C13E');
    endDot.setAttribute('stroke-width', '0.8');
    endDot.setAttribute('opacity', '0');
    mozGroup.appendChild(endDot);

    // Plane (moving dot along the path during flight)
    const plane = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    plane.setAttribute('r', '2.4');
    plane.setAttribute('fill', '#F5F1EA');
    plane.setAttribute('opacity', '0');
    mozGroup.appendChild(plane);

    return { dst, points, cumLen, totalLen, path, endDot, plane, endPt };
  });

  // Maputo marker (rendered last so it sits on top of arc start points)
  const maputoEl = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  maputoEl.setAttribute('cx', maputoScreen.x.toFixed(1));
  maputoEl.setAttribute('cy', maputoScreen.y.toFixed(1));
  maputoEl.setAttribute('r', '4.5');
  maputoEl.setAttribute('fill', '#F5F1EA');
  maputoEl.setAttribute('stroke', '#F0C13E');
  maputoEl.setAttribute('stroke-width', '1.8');
  mozGroup.appendChild(maputoEl);

  // ============== Flight animation timing ==============
  // Each arc cycles through: takeoff → flight → landing pulse → fade out → wait
  // Arcs are staggered so they fire in sequence (Matola first, Pemba last).
  const FLIGHT_MS = 1800;        // duration of in-flight drawing
  const PULSE_MS = 700;          // landing pulse duration
  const HOLD_MS = 600;           // hold trail before fading
  const FADE_MS = 900;           // fade-out duration
  const STAGGER_MS = 350;        // delay between successive arc launches
  const ARC_CYCLE_MS = FLIGHT_MS + PULSE_MS + HOLD_MS + FADE_MS;
  // Full sequence completes once all arcs have finished, then short pause, then repeat
  const TOTAL_CYCLE_MS = arcs.length * STAGGER_MS + ARC_CYCLE_MS + 1500;

  let lastTime = 0;
  let cycleStart = 0;

  // Easing for smoother flight
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  // ============== One-time static rendering of background dots ==============
  // (View is static, so no per-frame projection is needed for these.)
  for (let i = 0; i < worldPrecomp.length; i++) {
    const p = worldPrecomp[i];
    const v = transform({ x: p.cosPhi * Math.sin(p.lambda), y: p.y, z: p.cosPhi * Math.cos(p.lambda) });
    const el = worldEls[i];
    el.setAttribute('cx', (CX + R * v.x).toFixed(1));
    el.setAttribute('cy', (CY + R * v.y).toFixed(1));
    el.setAttribute('opacity', v.z > 0 ? (0.30 + v.z * 0.40).toFixed(2) : '0');
  }
  for (let i = 0; i < mozPrecomp.length; i++) {
    const p = mozPrecomp[i];
    const v = transform({ x: p.cosPhi * Math.sin(p.lambda), y: p.y, z: p.cosPhi * Math.cos(p.lambda) });
    const el = mozEls[i];
    el.setAttribute('cx', (CX + R * v.x).toFixed(1));
    el.setAttribute('cy', (CY + R * v.y).toFixed(1));
    el.setAttribute('opacity', v.z > 0 ? (0.45 + v.z * 0.15).toFixed(2) : '0');
  }

  // ============== Animation loop: flight path animations only ==============
  function render(time) {
    if (!cycleStart) cycleStart = time;
    const cycleTime = (time - cycleStart) % TOTAL_CYCLE_MS;

    // Maputo marker: gentle continuous pulse
    const mPulse = 4 + 1.2 * Math.sin(time * 0.003);
    maputoEl.setAttribute('r', mPulse.toFixed(2));

    // Per-arc flight animation
    for (let a = 0; a < arcs.length; a++) {
      const arc = arcs[a];
      const arcStart = a * STAGGER_MS;
      const arcLocalT = cycleTime - arcStart;

      // Default state: hidden
      let trailOpacity = 0;
      let visibleLen = 0;
      let planeOpacity = 0;
      let planePos = null;
      let endOpacity = 0;
      let endRadius = 2.2;

      if (arcLocalT < 0 || arcLocalT > ARC_CYCLE_MS) {
        // Outside this arc's window: fully hidden
      } else if (arcLocalT < FLIGHT_MS) {
        // PHASE 1 (in-flight): line draws, plane travels
        const t = easeInOutCubic(arcLocalT / FLIGHT_MS);
        visibleLen = arc.totalLen * t;
        trailOpacity = 0.75;
        planeOpacity = 0.95;
        // Find plane position by walking cumulative lengths
        const targetLen = visibleLen;
        let segIdx = 0;
        while (segIdx < arc.cumLen.length - 1 && arc.cumLen[segIdx + 1] < targetLen) segIdx++;
        const segStart = arc.cumLen[segIdx];
        const segEnd = arc.cumLen[Math.min(segIdx + 1, arc.cumLen.length - 1)];
        const segFrac = segEnd > segStart ? (targetLen - segStart) / (segEnd - segStart) : 1;
        const p0 = arc.points[segIdx];
        const p1 = arc.points[Math.min(segIdx + 1, arc.points.length - 1)];
        planePos = {
          x: p0.x + (p1.x - p0.x) * segFrac,
          y: p0.y + (p1.y - p0.y) * segFrac
        };
      } else if (arcLocalT < FLIGHT_MS + PULSE_MS) {
        // PHASE 2 (landing pulse): full trail and expanding endpoint
        const pt = (arcLocalT - FLIGHT_MS) / PULSE_MS;
        visibleLen = arc.totalLen;
        trailOpacity = 0.75;
        endOpacity = 1 - pt * 0.3;
        endRadius = 2.2 + 4 * Math.sin(pt * Math.PI);
      } else if (arcLocalT < FLIGHT_MS + PULSE_MS + HOLD_MS) {
        // PHASE 3 (hold): full trail, settled endpoint
        visibleLen = arc.totalLen;
        trailOpacity = 0.7;
        endOpacity = 0.85;
      } else {
        // PHASE 4: fade out
        const ft = (arcLocalT - FLIGHT_MS - PULSE_MS - HOLD_MS) / FADE_MS;
        visibleLen = arc.totalLen;
        trailOpacity = 0.7 * (1 - ft);
        endOpacity = 0.85 * (1 - ft);
      }

      arc.path.setAttribute('opacity', trailOpacity.toFixed(2));
      arc.path.setAttribute('stroke-dasharray', `${visibleLen.toFixed(1)} ${arc.totalLen.toFixed(1)}`);

      arc.endDot.setAttribute('opacity', endOpacity.toFixed(2));
      arc.endDot.setAttribute('r', endRadius.toFixed(2));

      if (planePos) {
        arc.plane.setAttribute('cx', planePos.x.toFixed(1));
        arc.plane.setAttribute('cy', planePos.y.toFixed(1));
        arc.plane.setAttribute('opacity', planeOpacity.toFixed(2));
      } else {
        arc.plane.setAttribute('opacity', '0');
      }
    }

    requestAnimationFrame(render);
  }

  requestAnimationFrame(render);
})();

// ============== SLIDE-IN DRAWERS, FORMS & TOAST ==============
(function initModals() {
  const backdrop = document.getElementById('modalBackdrop');
  const toast = document.getElementById('toast');
  const toastMsg = toast && toast.querySelector('.toast-msg');
  const formTmpl = document.getElementById('project-form-tmpl');
  if (!backdrop) return;

  let activeDrawer = null;
  let lastTrigger = null;
  let toastTimer = null;

  if (formTmpl) {
    document.querySelectorAll('[data-form-host]').forEach((host) => {
      const subject = host.getAttribute('data-subject') || '';
      const title = host.getAttribute('data-title') || 'Request a project';
      const intro = host.getAttribute('data-intro') || '';
      const showPractice = host.getAttribute('data-show-practice') === 'true';
      const noBack = host.getAttribute('data-no-back') === 'true';
      const titleId = host.getAttribute('data-title-id');
      const frag = formTmpl.content.cloneNode(true);
      const titleEl = frag.querySelector('.form-title');
      const introEl = frag.querySelector('.form-intro');
      const backBtn = frag.querySelector('.modal-back');
      const subjectInput = frag.querySelector('input[name="subject"]');
      const practiceRow = frag.querySelector('.practice-row');
      titleEl.textContent = title;
      if (titleId) titleEl.id = titleId;
      if (intro) {
        introEl.textContent = intro;
      } else {
        introEl.remove();
      }
      if (subjectInput) subjectInput.value = subject;
      if (showPractice && practiceRow) practiceRow.hidden = false;
      if (noBack && backBtn) backBtn.remove();
      host.appendChild(frag);
    });
  }

  function setView(views, viewName, direction) {
    if (!views) return;
    const content = views.querySelector('.modal-view-content');
    const form = views.querySelector('.modal-view-form');
    const showing = viewName === 'form' ? form : content;
    const hiding = viewName === 'form' ? content : form;
    if (!showing) return;
    if (hiding) hiding.hidden = true;
    showing.hidden = false;
    showing.classList.remove('enter-from-right', 'enter-from-left');
    void showing.offsetWidth;
    showing.classList.add(direction === 'left' ? 'enter-from-left' : 'enter-from-right');
    views.setAttribute('data-view', viewName);
    const body = views.closest('.modal-body');
    if (body) body.scrollTop = 0;
    const focusable = showing.querySelector('input, select, textarea, button');
    if (focusable) {
      setTimeout(() => focusable.focus({ preventScroll: true }), 60);
    }
  }

  function openDrawer(name, trigger) {
    const drawer = document.getElementById('modal-' + name);
    if (!drawer) return;
    if (activeDrawer && activeDrawer !== drawer) {
      activeDrawer.classList.remove('open');
      activeDrawer.setAttribute('aria-hidden', 'true');
    }
    activeDrawer = drawer;
    lastTrigger = trigger || null;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.classList.add('open');
    document.body.classList.add('modal-open');
    const views = drawer.querySelector('.modal-views');
    if (views) {
      const initial = views.getAttribute('data-view') === 'form' && !views.querySelector('.modal-view-content')
        ? 'form'
        : 'content';
      const content = views.querySelector('.modal-view-content');
      const form = views.querySelector('.modal-view-form');
      if (initial === 'content') {
        if (form) form.hidden = true;
        if (content) {
          content.hidden = false;
          content.classList.remove('enter-from-right', 'enter-from-left');
        }
        views.setAttribute('data-view', 'content');
      }
    }
    const body = drawer.querySelector('.modal-body');
    if (body) body.scrollTop = 0;
    const focusable = drawer.querySelector('.modal-close');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (!activeDrawer) return;
    activeDrawer.classList.remove('open');
    activeDrawer.setAttribute('aria-hidden', 'true');
    activeDrawer = null;
    backdrop.classList.remove('open');
    document.body.classList.remove('modal-open');
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus({ preventScroll: true });
    }
    lastTrigger = null;
  }

  function showToast(message) {
    if (!toast) return;
    if (toastMsg && message) toastMsg.textContent = message;
    toast.classList.add('show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 4200);
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal]');
    if (trigger) {
      e.preventDefault();
      openDrawer(trigger.getAttribute('data-modal'), trigger);
      return;
    }
    const formOpen = e.target.closest('[data-form-open]');
    if (formOpen) {
      e.preventDefault();
      const views = formOpen.closest('.modal-views');
      setView(views, 'form', 'right');
      return;
    }
    const formClose = e.target.closest('[data-form-close]');
    if (formClose) {
      e.preventDefault();
      const views = formClose.closest('.modal-views');
      setView(views, 'content', 'left');
      return;
    }
    if (e.target.closest('.modal-close') || e.target === backdrop) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && activeDrawer) closeDrawer();
    if (e.key === 'Enter' || e.key === ' ') {
      const card = e.target.closest('.three-card[data-modal]');
      if (card && document.activeElement === card) {
        e.preventDefault();
        openDrawer(card.getAttribute('data-modal'), card);
      }
    }
  });

  document.querySelectorAll('form[data-toast]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const successMessage = form.getAttribute('data-toast') || 'Submitted.';
      const errorMessage = 'Sorry, something went wrong. Please try again or email us directly.';
      const insideDrawer = form.closest('.modal-drawer');
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalLabel = submitBtn ? submitBtn.textContent : '';

      // Honeypot trip: silently no-op (looks successful to the bot).
      const honeypot = form.querySelector('input[name="bot-field"]');
      if (honeypot && honeypot.value) {
        form.reset();
        if (insideDrawer) closeDrawer();
        showToast(successMessage);
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending…';
      }

      const body = new URLSearchParams(new FormData(form)).toString();

      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body
      })
        .then((res) => {
          if (!res.ok) throw new Error('Network response was not ok');
          form.reset();
          if (insideDrawer) closeDrawer();
          showToast(successMessage);
        })
        .catch(() => {
          showToast(errorMessage);
        })
        .finally(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
        });
    });
  });
})();
